import styled from "styled-components";

export const SpinnerContainer = styled.div``;
export const SpinnerMessageSpan = styled.span`
  margin-left: 5px;
`;
